import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { DispatchDocPage } from "../";
import { TableOfContents } from "src/components";
import { Code, Line, Var } from "@molnx-sites/common/components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DispatchDocPage;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Reference`}</h1>
    <TableOfContents mdxType="TableOfContents" />
    <h2>{`Configuration Options`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      